import { useCallback, useContext } from 'react';
import _get from 'lodash/get';
import { AjaxContext, AppContext } from 'commons-ui';

import { UserDetailsContext } from 'context/userDetails';
import { DateFilter } from '../../types';
import { GET_LOTTERY_WINNINGS_LIST_ENDPOINT } from '../../constants';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName }
	} = useContext(AppContext);

	const {
		selectedUser: { uid }
	} = useContext(UserDetailsContext);

	const getLotteryWinningsListData = useCallback(async (props: { filters?: DateFilter }) => {
		const { filters } = props;
		const result: any = await postData({
			endpoint: GET_LOTTERY_WINNINGS_LIST_ENDPOINT,
			queryParams: {
				appName
			},
			body: {
				date: filters?.selectedDate || new Date().getTime().toString(),
				zuid: uid.toString()
			}
		});

		return {
			rowCount: 10,
			data: result?.data,
			nextPageId: _get(result, ['data', 'nextPageId'], null)
		};
	}, []);

	return {
		getLotteryWinningsListData
	};
};

export default useService;
